import datagrid from './datagrid.js';
import datagrid2 from './datagrid-2.js';

/**
 * LAYOUT DA ABA DATAGRID
 *
 * datagrid.js contém a configuração completa da grade e de seus recursos.
 * Este arquivo define somente o fieldset usado para apresentar a grade na aba.
 */
const datagridLayout = {
  element: 'group',
  type: 'tab',
  style: { width: '100%' },
  groups: [
    {
      legend: 'DataGrid 1',
      isGrid: true,
      content: [datagrid]
    },
    {
      legend: 'DataGrid 2',
      isGrid: true,
      content: [datagrid2]
    }
  ]
};

export default datagridLayout;
